import NiceModal, { useModal } from '@ebay/nice-modal-react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { t } from 'i18next'
import { useDeleteCompanyRoleMutation } from '../../hooks/useMutations/useRolesMutations'
import { useSnackbar } from '../../hooks/useSnackbar'

export const DeleteRoleModal = NiceModal.create(
  ({
    companyId,
    roleId,
    roleName
  }: {
    companyId: string
    roleId: string
    roleName: string
  }) => {
    const modal = useModal()
    const { showSnackbar } = useSnackbar()
    const deleteRoleMutation = useDeleteCompanyRoleMutation(companyId)

    const handleDelete = () => {
      deleteRoleMutation.mutate(
        { roleId },
        {
          onSuccess: () => {
            showSnackbar({
              message: t('delete_role_modal.success', {
                roleName: roleName
              }),
              severity: 'success'
            })
          },
          onError: () => {
            showSnackbar({
              message: t('delete_role_modal.error'),
              severity: 'error'
            })
          },
          onSettled: () => {
            modal.remove()
          }
        }
      )
    }

    return (
      <Dialog
        open={modal.visible}
        sx={{
          '& .MuiDialog-paper': {
            width: '32.563rem',
            padding: '1.5rem',
            borderRadius: '0.25rem'
          }
        }}
        onClose={() => modal.remove()}
      >
        <DialogTitle sx={{ padding: '1rem 1.5rem' }}>
          <Typography variant='h6' fontWeight='bold' component='span'>
            {t('delete_role_modal.title')}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '1.5rem !important' }}>
          <Typography variant='body1'>
            {t('delete_role_modal.content')}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: '0.5rem' }}>
          <Button
            variant='outlined'
            onClick={() => modal.remove()}
            sx={{
              borderRadius: '0.5rem',
              border: '1px solid rgba(121, 134, 203, 0.60)',
              background: 'rgba(121, 134, 203, 0.16)',
              color: 'rgba(121, 134, 203, 0.60)',
              textTransform: 'capitalize'
            }}
          >
            {t('common.cancel')}
          </Button>
          <Button
            variant='contained'
            onClick={handleDelete}
            sx={{ textTransform: 'capitalize', color: 'main.primary' }}
          >
            {t('delete_role_modal.delete')}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
)
